import type { IconSvgObject } from './types';

const ArrowUp04Icon: IconSvgObject = [
  ["path", { d: "M12 10L12 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9996 4L16 10H8L11.9996 4Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowUp04Icon;
